
  <div class="navigation">
    <div class="button-row">
      <span *ngFor="let link of links">
        <a mat-button href = "{{globals.getLocalizedValue(link.url)}}">{{globals.getLocalizedValue(link.name)}}</a>
      </span>
      <span *ngFor="let lang of globals.languages">
        <!--<a mat-button *ngIf="lang" lang="{{lang}}" (click)="changeLang(lang)" [ngClass]="{'selected-lang': lang===globals.lang}" tabindex="0" (keydown)="changeLang2($event, lang)">{{lang | uppercase}}</a>-->
        <button
          *ngIf="lang?.trim() as l"
          mat-button
          type="button"
          class="programme-item collection-item"
          [class.selected-lang]="l === globals.lang"
          (click)="changeLang(l)"
          [attr.aria-label]="langLabels[l]">
          {{ l | uppercase }}
        </button>

      </span>
    </div>
  </div>
